const booking = {
  bookingInformation: "Informazioni sulla prenotazione", // translated
  ourCancellationPolicy: "La nostra politica di cancellazione", // translated
  thisAupersedesAnyCancellationPolicyInRemarksAbove: "Ciò sostituisce qualsiasi politica di cancellazione nelle osservazioni di cui sopra", // translated
  thisBookingIsNonNefundable: "Questa prenotazione non è rimborsabile", // translated
  paymentTerms: "Termini di pagamento", // translated
  paymentWillBeTakenFromYourDefault: "Il pagamento verrà prelevato dal tuo default", // translated
  paymentMethod: "metodo di pagamento", // translated
  afterTheFreeCancellationPeriodIfApplicable: "dopo il periodo di cancellazione gratuita, se applicabile", // translated
  prebook: "Prenota in anticipo", // translated
  guests: "Ospiti", // translated
  payment: "Pagamento", // translated
  byClicking: "Cliccando", // translated
  youAreAgreeingToOur: "stai accettando il nostro", // translated
  termsAndConditions: "Termini e Condizioni", // translated
  lastBookableDate: "Ultima data prenotabile", // translated
  customerRemarksTextfield: "Osservazioni del cliente", // translated
  request: "Richiesta", // translated
};

export default booking;
